import translation from 'locales/translation';
import React, { Fragment, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Divider, Grid, Tooltip, Typography } from '@material-ui/core';
import { SyncIcon } from 'components/Icons';
import GenericModal, {
  IGenericModalProps,
} from 'components/Modal/__LEGACY__/GenericModal/GenericModal';

import { assembleiasAssessorLoadVotosInconsistentes } from 'store/modules/AssembleiasAssessorActions';
import { IVINucleo } from 'store/modules/AssembleiasAssessorReducer';
import { modalsActionsClose } from 'store/modules/ModalsActions';
import { IModalProps } from 'store/modules/ModalsReducer';
import { IReducer } from 'store/Reducer';

import useStyles from './style';

export interface IInconsistenciaVotosModalGenericProps
  extends IGenericModalProps {
  key: string;
  idEvento: number;
  present?: any;
  title?: any;
}

export interface IInconsistenciaVotosModal extends IModalProps {
  genericProps?: IInconsistenciaVotosModalGenericProps;
}

export default function InconsistenciaVotosModal({
  genericProps,
  open,
}: IInconsistenciaVotosModal) {
  const classes = useStyles();
  const dispatchAction = useDispatch();

  const { assembleiasAssessor } = useSelector((state: IReducer) => state);

  const toClose = useCallback((): void => {
    if (genericProps && genericProps.key) {
      dispatchAction(modalsActionsClose(genericProps.key));
    }
  }, [dispatchAction, genericProps]);

  const formataNucleo = (nucleo: IVINucleo[]) => {
    return nucleo.map((it) => it.nucleo).join(', ');
  };

  useEffect(() => {
    if (!genericProps?.present! && genericProps?.idEvento) {
      dispatchAction(
        assembleiasAssessorLoadVotosInconsistentes(genericProps.idEvento)
      );
    }
  }, [dispatchAction, genericProps]);

  const newObject = (arr: any) => {
    let mount: any = {
      agencia: [],
      nucleos: [],
    };

    // eslint-disable-next-line array-callback-return
    arr!?.map((o: any) => {
      if (!mount.agencia.includes(o.codigoAgencia)) {
        mount.agencia.push(o.codigoAgencia);
        const nuc = genericProps!?.present!?.inconsistencies.filter(
          (t: any) => t.codigoAgencia === o.codigoAgencia
        );
        mount.nucleos.push({
          agencia: o.codigoAgencia,
          nucleos: nuc,
        });
      }
    });
    return mount.nucleos;
  };

  let newArray = newObject(genericProps!?.present!?.inconsistencies);

  const getVotos = () => {
    return genericProps?.present ? (
      <React.Fragment>
        <Tooltip
          title={
            genericProps!?.title! ||
            genericProps!?.present!?.inconsistencies[0]!?.tituloPauta!
          }
          placement='bottom-start'
          arrow
        >
          <Typography component='h6' className={classes.nomPauta}>
            {translation.InconsistenciaDeVotosPresenciaisModal.nomePauta(
              genericProps!?.title!
            ) ||
              translation.InconsistenciaDeVotosPresenciaisModal.nomePauta(
                genericProps!?.present!?.inconsistencies[0]!?.tituloPauta!
              )}
          </Typography>
        </Tooltip>
        <Divider />
        <Grid container className={classes.itemHeader}>
          <Grid component={Typography} item xs={4} className={classes.itemHead}>
            {
              translation.InconsistenciaDeVotosPresenciaisModal.headerTitles
                .agencias
            }
          </Grid>
          <Grid
            component={Typography}
            item
            xs={8}
            className={[classes.itemHead, classes.itemHeadLeft].join(' ')}
          >
            {
              translation.InconsistenciaDeVotosPresenciaisModal.headerTitles
                .nucleos
            }
          </Grid>
        </Grid>
        <Grid container className={classes.item}>
          {newArray.map((item: any, index: number) => {
            return (
              <Fragment key={index}>
                <Grid
                  component={Typography}
                  item
                  xs={4}
                  className={classes.itemText}
                >
                  {item.agencia}
                </Grid>
                <Grid
                  component={Typography}
                  item
                  xs={8}
                  className={[classes.itemText, classes.itemTextLeft].join(' ')}
                >
                  {item.nucleos.map((nuc: any) => nuc.numeroNucleo).join(', ')}
                </Grid>
              </Fragment>
            );
          })}
        </Grid>
      </React.Fragment>
    ) : (
      assembleiasAssessor.votosInconsistentes.map((votIn) => {
        return (
          <React.Fragment key={votIn.idPauta}>
            <Tooltip title={votIn.tituloPauta} placement='bottom-start' arrow>
              <Typography component='h6' className={classes.nomPauta}>
                {translation.InconsistenciaDeVotosPresenciaisModal.nomePauta(
                  votIn.tituloPauta
                )}
              </Typography>
            </Tooltip>
            <Divider />
            <Grid container className={classes.itemHeader}>
              <Grid
                component={Typography}
                item
                xs={4}
                className={classes.itemHead}
              >
                {
                  translation.InconsistenciaDeVotosPresenciaisModal.headerTitles
                    .agencias
                }
              </Grid>
              <Grid
                component={Typography}
                item
                xs={8}
                className={[classes.itemHead, classes.itemHeadLeft].join(' ')}
              >
                {
                  translation.InconsistenciaDeVotosPresenciaisModal.headerTitles
                    .nucleos
                }
              </Grid>
            </Grid>
            <Grid container className={classes.item}>
              {votIn.listAgencia.map((agList) => (
                <React.Fragment key={agList.agencia}>
                  <Grid
                    component={Typography}
                    item
                    xs={4}
                    className={classes.itemText}
                  >
                    {agList.agencia}
                  </Grid>
                  <Grid
                    component={Typography}
                    item
                    xs={8}
                    className={[classes.itemText, classes.itemTextLeft].join(
                      ' '
                    )}
                  >
                    {formataNucleo(agList.nucleos)}
                  </Grid>
                </React.Fragment>
              ))}
            </Grid>
          </React.Fragment>
        );
      })
    );
  };

  return (
    <GenericModal
      open={open ?? false}
      title={translation.InconsistenciaDeVotosPresenciaisModal.title}
      genericProps={{
        maxWidth: 'sm',
        onClose: toClose,
        DialogContentProps: {
          className: classes.root,
        },
      }}
      content={
        <Grid container spacing={2}>
          {assembleiasAssessor.loadingVotosInconsistentes ? (
            <Grid item xs={12} className={classes.loadingContainer}>
              <SyncIcon animated />
              <Typography component='span'>
                {translation.InconsistenciaDeVotosPresenciaisModal.loadingDados}
              </Typography>
            </Grid>
          ) : (
            <>
              <Grid item xs={12}>
                <Typography className={classes.subTitle}>
                  {genericProps?.present!
                    ? translation.InconsistenciaDeVotosPresenciaisModal
                        .subTitlePresent
                    : translation.InconsistenciaDeVotosPresenciaisModal
                        .subTitle}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                {getVotos()}
              </Grid>
            </>
          )}
        </Grid>
      }
    />
  );
}
